import BlogListSlice from "./BlogListSlice";
import SEOSlice from "../SEOSlice";
import BreadcrumbsSlice from "./BreadcrumbsSlice";
import ButtonSlice from "./ButtonSlice";
import CardSlice from "./CardSlice";
import FooterCTASlice from "./FooterCTA";
import TestimonialSlice from "./TestimonialSlice";
import TopCapabilitiesHeroSlice from "./TopCapabilitiesHeroSlice";

export const topCapabilityComponents = {
  breadcrumbs: BreadcrumbsSlice,
  hero_slice: TopCapabilitiesHeroSlice,
  footer_cta: FooterCTASlice,
  card_list_slice: CardSlice,
  testimonial: TestimonialSlice,
  seo: SEOSlice,
  blog_list: BlogListSlice,
  button_slice: ButtonSlice,
}